import { doodBlockConfig } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PATTABLESELECTORPAGE_LEGACY_FIELD_ORDER = [
  
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  patTableSelectorPageDescriptor: _generatedPatTableSelectorPageDescriptor,
  patTableSelectorPageBlocDefinition,
  patTableSelectorPageDashboardLayout,
  patTableSelectorPageConfig,
  patTableSelectorPageResolveConfig,
  patTableSelectorPageProperties,
} = doodBlockConfig(
  {
    name: "Pay at table - Table selector",
    internal_name: "Pay at table - Table selector",
    url: "table-selector",
    defaultParent: [/^Main Layout$/i],
    componentType: 'PatTableSelectorPageComponent',
    category: 'page',
    description: "Pay at table - Table selector.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.pat-table-selector-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.pat-table-selector-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.pat-table-selector-page.fieldset.blocks.label",
            fields: ["body"],
          },
        ],
      },
    ],
  })
);

export function patTableSelectorPageDescriptor(): IBlockDescriptor;
export function patTableSelectorPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function patTableSelectorPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPatTableSelectorPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPatTableSelectorPageDescriptor, patTableSelectorPageProperties, fieldOrder);
}

export {
  patTableSelectorPageBlocDefinition,
  patTableSelectorPageDashboardLayout,
  patTableSelectorPageProperties,
  patTableSelectorPageConfig,
  patTableSelectorPageResolveConfig,
};

export type PatTableSelectorPageConfig = typeof patTableSelectorPageConfig;
